import { Maybe, Resource } from "@examspark/types";
export * from "./geom";
export * from "./timers";
export * from "./typedEventTarget";
export * from "./titleCase";

/**
 * type guard for definiedness. Primarily useful in a filter
 *
 */
export const exists = <T>(value: T | null | undefined): value is T =>
  value != null;

export const getContextsSafely = (
  data?:
    | Maybe<Maybe<Resource>[]>
    | {
        items: Maybe<Maybe<Resource>[]>;
      },
) => {
  if (!data) return [];
  if (Array.isArray(data)) return filterMaybeArray(data);
  if (data.items) return filterMaybeArray(data.items);
  return [];
};

export const filterMaybeArray = <T>(
  arr: Array<T | null | undefined> | null | undefined,
) => arr?.filter<T>(hasValue) ?? [];

export const hasValue = <T>(datum: T | null | undefined): datum is T => !!datum;

export {
  buildSearchFilterFromLaunchOptions,
  buildTagsSearchFilterFromContentFilter,
} from "./api/search";
